// extracted by mini-css-extract-plugin
export var modal = "Modal-module--modal--2c201";
export var start = "Modal-module--start--54bad";